import axiosInstance from '../../../utils/router/axiosInstance';
import { logger } from '../../../utils/logger';

const getEmployees = async () => {
    try {
        const allEmployeesResponse = await axiosInstance.get('website/employees');
        
        try {
            const onlineEmployeesResponse = await axiosInstance.get('website/employees/online');
            const onlineEmployees = onlineEmployeesResponse.data;

            const diffEmployees = allEmployeesResponse.data.map(employee => {
                const onlineEmployee = onlineEmployees.find(onlineEmp => onlineEmp.id === employee.id);
                if (onlineEmployee) {
                    return {
                        id: employee.id,
                        user_id: employee.user_id,
                        fio: employee.fio,
                        // WEB-7: должность для списка (поле аддитивно, рендер
                        // использует его только под REACT_APP_EMPLOYEE_CARD)
                        position: employee.position ?? null,
                        status: true
                    };
                } else {
                    return {
                        id: employee.id,
                        user_id: employee.user_id,
                        fio: employee.fio,
                        position: employee.position ?? null,
                        status: false
                    };
                }
            });

            return diffEmployees;
        } catch (error) {
            if (error.response && error.response.status === 404) {
                return allEmployeesResponse.data.map(employee => ({
                    id: employee.id,
                    user_id: employee.user_id,
                    fio: employee.fio,
                    position: employee.position ?? null,
                    status: false
                }));
            } else {
                throw error;
            }
        }
    } catch (error) {
        logger.error(error);
        return [];
    }
};

export default getEmployees;    
